import { useMonarchRule } from '../../MonarchRulesProvider';
import {
  CheckoutTestResult,
  CheckoutTestVariant,
  UseCheckoutTestHookResult,
} from './types';

const CUSTOM_RULE_ID = 'checkout';

type CheckoutProps = {
  showAlternateView: boolean;
  submitOrderCtaText: string;
  promoCodeCtaText: string;
  formTitleText: string;
  couponTitleText: string;
  cartTitleText: string;
  payPalTitleText: string;
};

const useCheckout: UseCheckoutTestHookResult = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    // https://admin.monarch.cohesionapps.com/sources/bdac7c16-924e-4180-bb35-5b2dfff6d308/content/native-returns/5b356d7c-c754-4a61-9bf4-6065a25db4b0/
    data: CheckoutProps;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as CheckoutTestResult;
  }

  // Determine the variant based on the returned data
  const variant: CheckoutTestVariant = value?.data?.showAlternateView
    ? 'test'
    : 'control';

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant,
    data: {
      showAlternateView: value.data.showAlternateView,
      submitOrderCtaText: value.data.submitOrderCtaText,
      promoCodeCtaText: value.data.promoCodeCtaText,
      formTitleText: value.data.formTitleText,
      couponTitleText: value.data.couponTitleText,
      cartTitleText: value.data.cartTitleText,
      payPalTitleText: value.data.payPalTitleText,
    },
  };
};

export default useCheckout;
